module.exports = __webpack_public_path__ + "static/media/video-metacognition-es.ea77fdc2.vtt";